import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type DniAnalysisTransformer } from './transformers'

export const viewMyAccountTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'view_my_account') return event
  if (platform === AnalyticsPlatforms.ALETHEIA) {
    return {
      eventName: 'view_my_account',
      eventParams: {
        ...event.eventParams,
      },
    }
  }
  return event
}
